import * as React from "react";
const SvgYoutrust = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Youtrust_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CEFF8F",
  d: "M14.4 0H9.6C6.24 0 4.56 0 3.276.654A6 6 0 0 0 .654 3.276C0 4.56 0 6.24 0 9.6v4.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C4.56 24 6.24 24 9.6 24h4.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C24 19.44 24 17.76 24 14.4V9.6c0-3.36 0-5.04-.654-6.324A6 6 0 0 0 20.724.654C19.44 0 17.76 0 14.4 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#191E1E",
  d: "m12.871 14.61 1.148 5.878a.06.06 0 0 1-.043.07 8.584 8.584 0 0 1-4.236 0 .06.06 0 0 1-.044-.07l1.147-5.878a6.62 6.62 0 0 0-.985-4.936l-3.07-4.599a.06.06 0 0 1 .01-.078c.641-.557 2.308-1.357 3.576-1.533.03-.005.06.017.064.048l1.228 6.196c.042.21.34.21.38 0l1.229-6.195a.06.06 0 0 1 .066-.047c1.258.194 2.822.922 3.57 1.53a.06.06 0 0 1 .012.08l-3.066 4.598a6.62 6.62 0 0 0-.986 4.936"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6969",
  d: "M10.072 12.364a2.43 2.43 0 0 0-1.178-1.686L4.279 8.025a.06.06 0 0 0-.08.024 8.8 8.8 0 0 0-.958 3.562.06.06 0 0 0 .052.062l5.451.736c.185.025.232.274.07.367l-4.832 2.746c-.026.014-.037.047-.026.076a8.8 8.8 0 0 0 2.15 2.998c.025.023.063.02.084-.006l3.391-4.272c.436-.549.616-1.26.492-1.954zM14.969 12.41l5.451-.735a.06.06 0 0 0 .052-.062 8.8 8.8 0 0 0-.958-3.562.057.057 0 0 0-.08-.024l-4.615 2.653a2.43 2.43 0 0 0-1.178 1.685 2.46 2.46 0 0 0 .492 1.954l3.391 4.272c.021.026.06.03.085.007a8.8 8.8 0 0 0 2.15-2.998.06.06 0 0 0-.025-.075l-4.833-2.746c-.162-.093-.116-.342.07-.367z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Youtrust_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgYoutrust;
//# sourceMappingURL=Youtrust.js.map